import { useEffect, useState } from 'react';
import { useAuthenticateUserQuery } from '../Apis/Common/authApi';
import { useNavigate, useLocation } from 'react-router-dom';
import { MainLoader } from '../Components/Common';
import { rtkErrorRead } from '../Helper';
import { getAuthToken } from '../Helper/authToken';

const withAuth = (WrappedComponent: any) => {
  return (props: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = getAuthToken();
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(
      null
    );

    const authUser = useAuthenticateUserQuery(null, {
      skip: !token, // Skip query if no token is present
    });

    useEffect(() => {
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      if (authUser.isError) {
        rtkErrorRead(authUser.error);
        setIsAuthenticated(false);
      } else if (authUser.isSuccess) {
        setIsAuthenticated(authUser.data?.isSuccess ?? false);
      }
    }, [token, authUser.isError, authUser.isSuccess, authUser.data]);

    useEffect(() => {
      if (isAuthenticated === false) {
        navigate('/auth/login', { replace: true, state: { from: location } });
      }
    }, [isAuthenticated, navigate, location]);

    if (authUser.isLoading || isAuthenticated === null) {
      return <MainLoader />; // Show loader while checking authentication
    }

    if (!isAuthenticated) {
      return null; // Prevent rendering before redirect
    }

    return <WrappedComponent {...props} />;
  };
};

export default withAuth;
